import React from "react";
import { t } from "../../../../utils/i18n";

const CurrencyInfoSection = () => {
  return (
    <div className="currency-info-section">
      <h2 className="currency-info-title">{t("store_integrations.widget.cc_title")}</h2>
      <p>
        {t("store_integrations.widget.cc_intro")}
      </p>
      <ul className="currency-info-list">
        <li>
          {t("store_integrations.widget.cc_li1")}
        </li>
        <li>
          {t("store_integrations.widget.cc_li2")}
        </li>
        <li>
          {t("store_integrations.widget.cc_li3")}
        </li>
        <li>
          {t("store_integrations.widget.cc_li4")}
        </li>
      </ul>
      <div className="api-note">
        <p className="api-note-title">{t("store_integrations.widget.api_note_title")}</p>
        <p>
          {t("store_integrations.widget.api_note_intro")}
        </p>

        {/* Table for larger screens */}
        <table className="param-table">
          <thead>
            <tr>
              <th>{t("store_integrations.widget.th_parameter")}</th>
              <th>{t("store_integrations.widget.th_description")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span className="param-name">store_id</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_store_id")}</td>
            </tr>

            <tr>
              <td>
                <span className="param-name">amount</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_amount")}</td>
            </tr>
            <tr>
              <td>
                <span className="param-name">currency</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_currency")}</td>
            </tr>
            <tr>
              <td>
                <span className="param-name">usd_amount</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_usd_amount")}</td>
            </tr>
            <tr>
              <td>
                <span className="param-name">description</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_description")}</td>
            </tr>
            <tr>
              <td>
                <span className="param-name">redirect_url</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_redirect_url")}</td>
            </tr>
            <tr>
              <td>
                <span className="param-name">order_id</span>
              </td>
              <td>{t("store_integrations.widget.cc_p_order_id")}</td>
            </tr>
          </tbody>
        </table>

        {/* List for mobile screens */}
        <ul className="param-list">
          <li>
            <span className="param-name">store_id</span> - {t("store_integrations.widget.cc_p_store_id")}
          </li>

          <li>
            <span className="param-name">amount</span> - {t("store_integrations.widget.cc_p_amount")}
          </li>
          <li>
            <span className="param-name">currency</span> - {t("store_integrations.widget.cc_p_currency")}
          </li>
          <li>
            <span className="param-name">usd_amount</span> - {t("store_integrations.widget.cc_p_usd_amount")}
          </li>
          <li>
            <span className="param-name">description</span> - {t("store_integrations.widget.cc_p_description")}
          </li>
          <li>
            <span className="param-name">redirect_url</span> - {t("store_integrations.widget.cc_p_redirect_url")}
          </li>
          <li>
            <span className="param-name">order_id</span> - {t("store_integrations.widget.cc_p_order_id")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CurrencyInfoSection;
